import { relations } from 'drizzle-orm';
import { integer, pgTable, primaryKey } from 'drizzle-orm/pg-core';
import { event } from './event';
import { webhookEndpoint } from './webhook-endpoint';

export const eventsToEndpoints = pgTable(
  'events_to_endpoints',
  {
    event_id: integer()
      .references(() => event.id, { onDelete: 'cascade' })
      .notNull(),
    endpoint_id: integer()
      .references(() => webhookEndpoint.id, { onDelete: 'cascade' })
      .notNull(),
  },
  (t) => [primaryKey({ columns: [t.event_id, t.endpoint_id] })],
);

export const eventsToEndpointsRelations = relations(eventsToEndpoints, ({ one }) => ({
  endpoint: one(webhookEndpoint, {
    fields: [eventsToEndpoints.endpoint_id],
    references: [webhookEndpoint.id],
  }),
  event: one(event, {
    fields: [eventsToEndpoints.event_id],
    references: [event.id],
  }),
}));
